import React, { useContext, useEffect } from 'react'
import { UserDataContext } from '../context/UserContext'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-hot-toast'

const UserProtectedWrapper = ({ children, requiredRole }) => {
    const { user, isLoading } = useContext(UserDataContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!isLoading) {
            if (!user || user.authenticated === false) {
                if (location.pathname !== '/' && location.pathname !== '/login' && location.pathname !== '/collector-login') {
                    toast.error("Please Login to access this page");
                }
                // Decide where to redirect based on requiredRole or just to a default login
                if (requiredRole === 'COLLECTOR') {
                    navigate('/collector-login');
                } else {
                    navigate('/login');
                }
            } else if (requiredRole && user.role !== requiredRole) {
                if (location.pathname !== '/') {
                    toast.error("You do not have permission to access this page");
                }
                // Redirect to their respective home
                if (user.role === 'COLLECTOR') {
                    navigate('/collectors-home');
                } else {
                    navigate('/');
                }
            }
        }
    }, [user, isLoading, navigate, requiredRole, location]);

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00BFA5]"></div>
            </div>
        );
    }

    if (!user || user.authenticated === false || (requiredRole && user.role !== requiredRole)) {
        return null;
    }

    return (
        <> {children} </>
    )
}

export default UserProtectedWrapper;